import React, {Component} from "react";
import TopNav from "../../../common/nav/TopNav";
import Footer from "../../../common/Footer";
import PageBlock from "../../../common/PageBlock";

class FAQ extends Component {
    render() {
        return (
            <div>
                <TopNav tab="docs"/>

                <PageBlock>
                    <div className="container">

                        <div className="row">
                            <div className="col-lg-12">
                                <h1 className="page-header">Frequently asked questions</h1>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h4>
                                    What are API Mocks?
                                </h4>
                                <p>Use API mocks to:</p>
                                <ul>
                                    <li>run standalone mocks in place of real systems</li>
                                    <li>turn an OpenAPI file into a mock API for testing or QA</li>
                                    <li>quickly set up a temporary API for your mobile/web client teams whilst the real API is being built</li>
                                    <li>decouple your integration tests from the cloud/various back-end systems and take control of your dependencies</li>
                                </ul>
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-sm-12">
                                <h4>
                                    What is OpenAPI?
                                </h4>
                                <p>OpenAPI, formerly known as Swagger, is a specification for describing APIs.
                                    It is widely adopted in the software industry as a means to document and share
                                    API specifications.</p>
                                <p>Learn more about OpenAPI on <a
                                    href="https://www.openapis.org/" target="_blank">the project site</a>.</p>
                            </div>
                        </div>

                    </div>
                </PageBlock>

                <Footer/>
            </div>
        );
    }
}

export default FAQ;



// WEBPACK FOOTER //
// ./src/modules/views/docs/mocks/FAQ.js